function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconQuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#00458B",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 12 6 L 12 18 ",
    transform: "matrix(1.25,0,0,1.25,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#00458B",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 6 12 L 18 12 ",
    transform: "matrix(1.25,0,0,1.25,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconQuest);
export default __webpack_public_path__ + "static/media/plus-icon-quest.e6d645e0792555d31d09fe3329e0b642.svg";
export { ForwardRef as ReactComponent };